export default class DisplayForm {

    constructor() {
        this.bindUIActions();
    }

    bindUIActions() {

        $('.js-form-btn').on('click', (e) => {
            
            const $this = $(e.currentTarget);

            // Show the matching form when clicking a form selector button and hide the others

            const formId = $this.data('form-btn-id');
            const heading = $('[data-form-heading-id="' + formId + '"]');
            $('.js-form-heading').addClass('hidden');
            heading.removeClass('hidden');
            $('.js-form-btn').removeClass('active');
            $this.addClass('active');
            $('.js-form').removeClass('active').addClass('hidden');
            $('.js-form-' + formId).removeClass('hidden').addClass('active');
        });

    }

};

new DisplayForm();